 
import react1 from '../img/portImages/garment.png';
import organicshop from '../img/portImages/organicshop.jpg';
 

const portfolios = [
    // {
    //     id: 1,
    //     category: 'CSS',
    //     image: css1,
    //     link1: 'https://www.google.com',
    //     link2: 'https://www.google.com',
    //     title: 'Responsive Resume',
    //     text: 'Created with only HTML and CSS.'
    // },


    // {
    //     id: 2,
    //     category: 'Python',
    //     image: img3,
    //     link1: 'https://www.google.com',
    //     link2: 'https://www.google.com',
    //     title: 'How To Animate In Maya',
    //     text: 'Number one Animation Application'
    // },


    // {
    //     id: 3,
    //     category: 'Javascript',
    //     image: img3,
    //     link1: 'https://www.google.com',
    //     link2: 'https://www.google.com',
    //     title: 'How To Animate In Maya',
    //     text: 'Number one Animation Application'
    // },

    // {
    //     id: 4,
    //     category: 'Animation',
    //     image: img2,
    //     link1: 'https://www.google.com',
    //     link2: 'https://www.google.com',
    //     title: 'How To Use Blender',
    //     text: 'Free Animation Software'
    // },


    // {
    //     id: 5,
    //     category: 'Animation',
    //     image: img2,
    //     link1: 'https://www.google.com',
    //     link2: 'https://www.google.com',
    //     title: 'How To Use Blender',
    //     text: 'Free Animation Software'
    // },
    {
        id: 1,
        category: 'MERN STACK',
        image: 'https://i.ibb.co/nftMPb0/doctors-portal.png',
        link1: 'https://github.com/ImranProgrammer10/doctors-portal-client-module-71',
        link2: 'https://doctors-portal-70652.web.app/',
        title: 'DCTORS PORTAL',
        text: 'Created using different technologies such as Material UI, Styled-Components and more...'
    },
    {
        id: 2,
        category: 'MERN STACK',
        image: 'https://i.ibb.co/wQJNG2C/ecommerce.png',
        link1: 'https://github.com/ImranProgrammer10/mb10-ecommerce-client',
        link2: 'https://mb10-ecommerce.web.app/',
        title: 'MB10 E-COMMERCE SITE',
        text: 'Created using different technologies such as Tailwind ,Firebase, Mern and more...'
    },
    {
        id: 3,
        category: 'React JS',
        image: react1,
        link1: 'https://github.com/ImranProgrammer10/rahmatknittex',
        link2: 'https://vermillion-kataifi-9c7a89.netlify.app/',
        title: 'Garment Website',
        text: 'Created using different technologies such as Material UI, Styled-Components and more...'
    },
    {
        id: 4,
        category: 'MERN STACK',
        image: organicshop,
        link1: 'https://github.com/ImranProgrammer10/E-commerce-app-2023',
        link2: 'https://lovely-underclothes-dog.cyclic.app/',
        title: 'Organic E commerce Site',
        text: 'Created using different technologies such as Bootstrap , Styled-Components,Full Stack Mern E commerce Site and more...'
    },
    // {
    //     id: 7,
    //     category: 'CSS',
    //     image: css2,
    //     link1: 'https://www.google.com',
    //     link2: 'https://www.google.com',
    //     title: 'Microsoft Website Clone',
    //     text: 'Created using HTML and CSS'
    // }
]

export default portfolios;